
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/LiveSearch.html",
      function () {
        return require("private-next-pages/Forms/LiveSearch.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/LiveSearch.html"])
      });
    }
  